export const GET_VAT_ENTRIES_SUCCESS = "GET_VAT_ENTRIES_SUCCESS";

export function getVatEntries() {
  return (dispatch) => {
    dispatch({
      type: GET_VAT_ENTRIES_SUCCESS
    });
  };
}
